import type { IUser } from '@carboncopyco/types';
import { capitalize } from '@carboncopyco/utils';
import { stringToColor } from '../../utils';
import type { AvatarSize } from '../Avatar';
import { Avatar } from '../Avatar';

export interface UserAvatarProps {
  user: Pick<IUser, 'firstName' | 'lastName' | 'image'> &
    Partial<Pick<IUser, 'isDeleted' | 'name'>>;
  size?: AvatarSize;
}

function getInitials(user: UserAvatarProps['user']) {
  if (user.firstName) {
    return `${user.firstName[0] ?? ''}${user.lastName[0] ?? ''}`;
  }
  if (user.name) {
    return `${capitalize(
      user.name
        .split(' ')
        .map((word) => word.charAt(0))
        .join()
        .replaceAll(',', '')
        .slice(0, 2)
    )}`;
  }
  if (!user.name && !user.firstName) {
    return 'A';
  }
}

export const UserAvatar = ({ user, size }: UserAvatarProps) => {
  const initials = getInitials(user);
  const backgroundColor = stringToColor(
    user.firstName
      ? `${user.firstName}${user.lastName}`
      : user.name ?? 'Anonymous'
  );

  if (user?.isDeleted) {
    return (
      <Avatar
        initials={initials}
        backgroundColor="bg-ds-natural-200-a"
        color="text-ds-natural-200"
        size={size}
      />
    );
  }

  return (
    <Avatar
      initials={initials}
      image={user?.image}
      size={size}
      backgroundColor={backgroundColor}
    />
  );
};
